/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Dialog_SubtitleInputs */



/**
* | output |
* | --- |
* | "Search for an address or click on the map" |
*
* @param {Position_Dialog_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const position_dialog_subtitle = /** @type {((inputs?: Position_Dialog_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Dialog_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Search for an address or click on the map")
	return /** @type {LocalizedString} */ ("Rechercher une adresse ou cliquer sur le plan")
});